import * as React from 'react';
import { Button, ButtonGroup, Popover, PopoverBody } from 'reactstrap';
import Icon from '../../../widgets/Icons';
import { DATA_DIRECTIONS } from './data_constants';
import ChoiceSelector, { Choice } from '../../../widgets/ChoiceSelector';
import { SetFilterValuesFunction } from '../../FilterManager';

const ID_PREFIX = 'pb_';

export enum AdditionalPivotTypes {
  DIRECTION = 'direction',
}

type DirectionPivot = {
  type: 'direction';
  filterKey: string;
};

export type AdditionalPivots = DirectionPivot;

type TrafficDirProps = {
  value: string | null;
  onChange: (arg0: string) => void;
};

export class TrafficDirectionSplitButton extends React.PureComponent<TrafficDirProps> {
  handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    this.props.onChange(event.currentTarget.name);
  };

  render() {
    const { value } = this.props;
    return (
      <div className="d-flex flex-column">
        <div className="text-center">Traffic Direction</div>
        <ButtonGroup>
          <Button
            color="primary"
            className="choice-button"
            name={DATA_DIRECTIONS.INBOUND}
            onClick={this.handleClick}
            disabled={value === DATA_DIRECTIONS.INBOUND}
          >
            <Icon.Inbound />
            <span className="ml-2">In</span>
          </Button>
          <Button
            color="primary"
            className="choice-button"
            name={DATA_DIRECTIONS.OUTBOUND}
            onClick={this.handleClick}
            disabled={value === DATA_DIRECTIONS.OUTBOUND}
          >
            <Icon.Outbound />
            <span className="ml-2">Out</span>
          </Button>
        </ButtonGroup>
      </div>
    );
  }
}

export type Props = {
  viewChoices: Array<Choice>;
  disabledPivots: Array<string>;
  filters: URLSearchParams;
  additionalPivots?: Array<AdditionalPivots>;
  index: number;
  isOpen: boolean;
  onPivot: (arg0: number, arg1: string) => void;
  setFilterValues: SetFilterValuesFunction;
  togglePopup: (arg0: number | null) => void;
};

export default class PivotButton extends React.PureComponent<Props> {
  toggle = () => {
    const { index, togglePopup } = this.props;
    togglePopup(index);
  };

  doPivot = (view: string) => {
    const { index, togglePopup, onPivot } = this.props;
    togglePopup(null);
    onPivot(index, view);
  };

  render() {
    const {
      index,
      isOpen,
      viewChoices,
      filters,
      disabledPivots,
      additionalPivots,
      setFilterValues,
    } = this.props;
    return (
      <div>
        <div
          className="cursor-pointer"
          style={{
            borderRadius: '3px',
            padding: '3px 5px 5px',
            maxWidth: '35px',
            color: '#96A6AC',
          }}
          id={ID_PREFIX + index}
          onClick={this.toggle}
        >
          <Icon.ZoomIn size={24} />
        </div>
        <Popover
          className="pivot-popover"
          placement="bottom-end"
          isOpen={isOpen}
          target={ID_PREFIX + index}
          toggle={this.toggle}
          trigger="legacy"
        >
          <PopoverBody className="d-flex">
            <ChoiceSelector
              choices={viewChoices}
              onChange={this.doPivot}
              disabledValues={disabledPivots}
              asRadioButtons={false}
            />
            {additionalPivots?.map((pivot, index) => {
              switch (pivot.type) {
                case 'direction':
                  return (
                    <TrafficDirectionSplitButton
                      key={index}
                      value={filters.get(pivot.filterKey)}
                      onChange={(direction: string) => {
                        setFilterValues([
                          { key: pivot.filterKey, value: direction },
                        ]);
                      }}
                    />
                  );
                default:
                  return null;
              }
            })}
          </PopoverBody>
        </Popover>
      </div>
    );
  }
}
